"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/RichMessageWrapper/ReactionPicker.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _EmojiPicker = require('web/components/Conversation/EmojiPicker'); var _EmojiPicker2 = _interopRequireDefault(_EmojiPicker);
var _Tooltip = require('web/components/Tooltip');

const QUICK_REACTIONS = ['👍', '❤️', '😂', '😮', '😢', '🎉']










const QuickReaction = ({ emoji, onSelect }) => {
  const handleClick = _react.useCallback.call(void 0, () => onSelect(emoji), [onSelect, emoji])
  return (
    _react2.default.createElement('button', {
      type: "button",
      onClick: handleClick,
      'aria-label': `React with ${emoji}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 20}}

      , emoji
    )
  )
}

const ReactionPicker = ({ onSelect }) => {
  const [isFullPickerOpen, setIsFullPickerOpen] = _react.useState.call(void 0, false)
  const selectEmoji = _react.useCallback.call(void 0, 
    (emoji) => {
      setIsFullPickerOpen(false)
      onSelect(emoji)
    },
    [onSelect],
  )
  const openFullPicker = _react.useCallback.call(void 0, () => setIsFullPickerOpen(true), [])
  const closeFullPicker = _react.useCallback.call(void 0, () => setIsFullPickerOpen(false), [])

  return (
    _react2.default.createElement('div', { className: "rich-message--reaction-picker", __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}
      , QUICK_REACTIONS.map(emoji => (
        _react2.default.createElement(QuickReaction, { key: emoji, emoji: emoji, onSelect: selectEmoji, __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}} )
      ))
      , _react2.default.createElement(_Tooltip.ControlledTooltip, {
        isOpen: isFullPickerOpen,
        place: "top",
        onClose: closeFullPicker,
        content: _react2.default.createElement(_EmojiPicker2.default, { onSelect: selectEmoji, __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}} ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}

        , _react2.default.createElement('button', {
          type: "button",
          onClick: openFullPicker,
          'aria-label': "More reactions" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}
, "+"

        )
      )
    )
  )
}

exports. default = ReactionPicker
